import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { ImageService } from '../../typewriter/output/ImageController';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Output() fileUploaded = new EventEmitter<string>();
  @Input() caption = 'Upload your image file...';

  fileToUpload: File = null;
  upload: Observable<any> = null;
  uploading: boolean = false;
  status: string;

  constructor(
    private http: Http,
    private imageService: ImageService
  ) { }

  ngOnInit() {
  }

  //file upload event  
  fileChange(event) {
    this.status = 'Uploading...';
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.uploading = true;
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      let headers = new Headers()
      //headers.append('Content-Type', 'json');  
      //headers.append('Accept', 'application/json');  
      let options = new RequestOptions({ headers: headers });
      let apiUrl1 = `${environment.apiUrl}api/image/upload`;
      this.upload = this.http.post(apiUrl1, formData, options).share();
      this.upload.map(response => {
        this.uploading = false;
        this.fileUploaded.emit(response.json());
        return response.json();
      })
        .catch(error => {
          this.uploading = false;
          return Observable.throw(error);
        })
        .subscribe(
        data => {
          this.uploading = false;
          this.status = 'File uploaded successfully.';
        },
        error => {
          this.uploading = false;
          this.status = error;
        });
    }
    //window.location.reload();
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/file-upload/file-upload.component.ts